import { server } from '@/helpers';

export const turnstileServices = {
  verify,
};

async function verify(token: string) {
  return server.request.post('/verify-turnstile', { token });
}
